import React from "react";
import { BRAND_NAME, LOGO_ICON_URL } from "../shared/ui/brand";
import { colors, FONTS } from "../shared/ui/tokens";
import { useBreakpoint } from "../shared/ui/useBreakpoint";

// ── Pied de page — thème clair ───────────────────────────────────────────────
const F = {
  bg: colors.neutral[0],
  border: colors.neutral[200],
  brand: colors.brand[600],
  text: colors.neutral[500],
  muted: colors.neutral[400],
};

const Footer: React.FC = () => {
  const { isMobile } = useBreakpoint();

  return (
    <footer
      style={{
        background: F.bg,
        borderTop: `1px solid ${F.border}`,
        padding: isMobile ? "10px 16px" : "10px 28px",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        justifyContent: "space-between",
        gap: isMobile ? 6 : 12,
        minHeight: 46,
        flexShrink: 0,
        fontFamily: FONTS.body,
      }}
    >
      {/* ── Logo + nom ── */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <img
          src={LOGO_ICON_URL}
          alt={BRAND_NAME}
          style={{ width: 22, height: 22, objectFit: "contain" }}
        />
        <span
          style={{
            fontFamily: FONTS.heading,
            fontWeight: 700,
            fontSize: 12,
            color: F.brand,
          }}
        >
          AvDash
        </span>
        {!isMobile && (
          <span style={{ fontSize: 11, color: F.text }}>
            Intelligence Décisionnelle
          </span>
        )}
      </div>

      {/* ── Copyright ── */}
      <div style={{ fontSize: 11, color: F.muted, textAlign: "center" }}>
        © {new Date().getFullYear()} AvDash — Tous droits réservés
      </div>

      {/* ── Développé par ── */}
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span
          style={{
            fontSize: 10,
            color: F.muted,
            letterSpacing: 1,
            textTransform: "uppercase",
            fontWeight: 600,
          }}
        >
          Développé par
        </span>
        {/* Logo blanc d'origine, rendu gris sur fond clair */}
        <img
          src="/image.png"
          alt="Avantages Soft"
          style={{
            height: 20,
            width: "auto",
            objectFit: "contain",
            filter: "brightness(0)",
            opacity: 0.55,
          }}
        />
      </div>
    </footer>
  );
};

export default Footer;
